import React, { useState } from 'react';

import { useUserStore } from '../../stores/userStore';
import Login from './Login';
import Register from './Register';

interface AuthWrapperProps {
  children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const authDisabled = (import.meta as any).env?.VITE_AUTH_DISABLED === 'true';
  const { isAuthenticated } = useUserStore();
  const [isLogin, setIsLogin] = useState(true);

  if (authDisabled || isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <>
      {isLogin ? (
        <Login onSwitchToRegister={() => setIsLogin(false)} />
      ) : (
        <Register onSwitchToLogin={() => setIsLogin(true)} />
      )}
    </>
  );
};

export default AuthWrapper;
